import { useTableLayoutFromSettings } from '@Hooks/index';
import { TableModal, type IId, type ITableModalProperties } from '@synqo/frontend-component-library';
import type { EnumFrontendLayoutSetting } from '@Model';
import { useMemo } from 'react';

export type TableModalWithLayoutSettingsProps<TItem extends IId> = ITableModalProperties<TItem> & {
    layoutSettingsContext: EnumFrontendLayoutSetting;
};

export function TableModalWithLayoutSettings<TItem extends IId>({
    layoutSettingsContext,
    ...props
}: TableModalWithLayoutSettingsProps<TItem>) {
    const { columnSizing, columnVisibility, updateSizing, updateVisibility } = useTableLayoutFromSettings(
        layoutSettingsContext,
        props.tableProps.columns,
    );

    // Merged rather than passed through, so a caller that memoises its own tableProps keeps the
    // stable identity all the way to the table instead of losing it here.
    const tableProps = useMemo(
        () => ({
            ...props.tableProps,
            columnSizing,
            columnVisibility,
            onSizesChange: updateSizing,
            onVisibilityChange: updateVisibility,
        }),
        [props.tableProps, columnSizing, columnVisibility, updateSizing, updateVisibility],
    );

    return <TableModal {...props} tableProps={tableProps} />;
}
